import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import SurveyLayout from "./SurveyLayout";
import { SurveyAlreadyCompleted, SurveyLoading } from "./SurveyStatus/SurveyStatuses";
import { useSurveyLayout } from "./useSurveyLayout";
import SurveyStart from "./Survey/SurveyStart";
import SurveyForm from "./Survey/SurveyForm";
import SurveyComplete from "./SurveyComplete";
import {
    ParticipantQueryOptions,
    QuestionsForParticipantsQueryOptions,
    surveyForParticipantOptions,
} from "@pulse/api/queryApi";

export function SurveySteps() {
    const { stepType } = useSurveyLayout();
    return (
        <>
            {stepType === "start" && <SurveyStart />}
            {stepType === "question" && <SurveyForm />}
            {stepType === "complete" && <SurveyComplete />}
        </>
    );
}

export default function SurveyResponse() {
    const participantId = useParams({ from: "/pulse/surveys/$participantId" }).participantId;
    const { data: participant, isLoading: isLoadingParticipant } = useQuery(
        ParticipantQueryOptions({ participantId }),
    );

    // Only fetch survey when participant data is available
    const { data: survey, isLoading: isLoadingSurvey } = useQuery({
        ...surveyForParticipantOptions({ surveyId: participant?.surveyId || 0 }),
        enabled: !!participant?.surveyId && !participant?.answered,
    });

    // Only fetch questions when survey data is available
    const { data: questions, isLoading: isLoadingQuestions } = useQuery({
        ...QuestionsForParticipantsQueryOptions({ surveyId: survey?.id || 0 }),
        enabled: !!survey?.id && !participant?.answered && survey?.status === "ACTIVE",
    });

    return (
        <>
            <SurveyLayout
                survey={survey}
                questions={questions}
                isLoading={isLoadingParticipant || isLoadingSurvey || isLoadingQuestions}
            >
                {isLoadingParticipant && <SurveyLoading />}
                {participant && participant.answered && <SurveyAlreadyCompleted />}
                {participant && !participant.answered && <SurveySteps />}
            </SurveyLayout>
        </>
    );
}
